import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NouvelleLocationsComponent } from '../nouvelle-locations/nouvelle-locations.component';

@Component({
  selector: 'app-list-locations',
  standalone: false,
  templateUrl: './list-locations.component.html',
  styleUrl: './list-locations.component.scss'
})
export class ListLocationsComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  statut: any = '';
  isDisabled: boolean = false;
  hasError = false;
  errorMessage = '';
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalContent1') modalContent1: TemplateRef<any>;
  detailsItems: any


  constructor(
    private router: Router,
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private paramService: ParameterService,
  ) {

    this.getDemandeLocation();
   }



  newLocation(){
    this.router.navigate(['/ikena/nouvelle-location']);
  }

  getDemandeLocation() {
    this.isLoading = true;
    this.hasError = false; 

    this.paramService.getDemandeLocation().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();

        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        //console.log("une erreu est survenu", error);
        this.isLoading = false; 
        this.hasError = true;
        this.errorMessage = 'Impossible de charger les données'; 
      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }
  addOpenModal() {
    this.modalService.open(NouvelleLocationsComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }
  searchByPeriode() {
    if (!this.dateDebut) {
      this.messageService.add({ severity: 'info', summary: "EPOM", detail: "Veuillez choisir une date de début" });
      return;
    }
    if (!this.dateFin) {
      this.messageService.add({ severity: 'info', summary: "EPOM", detail: "Veuillez choisir une date de fin" });
      return;
    }
    // if (!this.searchGender) {
    //   this.messageService.add({ severity: 'info', summary: "EPOM", detail: "Veuillez choisir le sexe" });
    //   return;
    // }
    else {
      this.ngxService.start();
      const requestData = {
        "statut": this.statut,
        "date_debut": this.dateDebut,
        "date_fin": this.dateFin,
        //"sexe": this.searchGender,
      }
      this.paramService.searchByPeriode(requestData).subscribe(
        (response: any) => {
          this.ngxService.stop();

          this.filteredtems = response.data;
          if (this.filteredtems.length === 0) {
            this.messageService.add({ severity: 'info', summary: 'EPOM', detail: "Aucune donnée trouvée", life: 3000 });
            this.updatePaginated();

            return;
          }
          if (this.filteredtems.length > 0) {
            this.isDisabled = true;

          }
          //console.log("this.filteredtems", this.filteredtems);
          this.updatePaginated();
          this.messageService.add({ severity: 'success', summary: 'EPOM', detail: response.message, life: 3000 });

        },
        (error) => {
          //console.log("une erreu est survenu", error);
          this.ngxService.stop();
          this.messageService.add({ severity: 'error', summary: 'EPOM', detail: error, life: 3000 });

        }
      )
    }

  }
  openModal(item:any) {
    this.detailsItems = item
    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  // editOpenModal(item: any) {
  //   this.localstorage.saveCertificatDeces(item);
  //   this.modalService.open(UpdateCertificatDecesComponent, {
  //     centered: true,
  //     backdrop: 'static',
  //     size: 'xl'
  //   });
  // }
}
